<template>
  <DefaultLayout :pageProps="customer.loginPage">
    <template #content>
      <LoginForm @success="success" />
    </template>
  </DefaultLayout>
</template>

<script>
import LoginForm from "@/components/forms/loopLogin/LoginForm";
import DefaultLayout from "../../layout/DefaultLayout.vue";
import { CUSTOMER as customer } from "../../environment/env.customer";

export default {
  name: "index",
  computed: {
    customer() {
      return customer;
    },
  },
  components: { DefaultLayout, LoginForm },
  methods: {
    success() {
      this.$router.push("/code");
    },
  },
};
</script>
